var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',_vm._g(_vm._b({attrs:{"css":! _vm.transitionHooks}},'Transition',_vm.transition,false),_vm.transitionHooks),[(_vm.isOpen)?_c('div',{class:{
			'screen': true,
			'is-open': _vm.isOpen,
		},attrs:{"id":_vm.id,"role":"main","tabindex":"-1"}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }